module.exports = __webpack_public_path__ + "static/media/logo1.0e0bf0e3.svg";